/**
 * Pull a human-readable message out of an API failure.
 *
 * The API answers with { error }, { message } or a validation { errors } map
 * depending on the endpoint, and a network failure has none of them. Callers
 * used to spell out that chain themselves, which is why the same
 * `err.response?.data?.error || err.message || '...'` appeared in dozens of
 * places with slightly different fallbacks.
 */
export const getErrorMessage = (error, fallback = 'Something went wrong. Please try again.') => {
  const data = error?.response?.data;

  if (typeof data === 'string' && data.trim()) return data.trim();

  if (data?.error) return String(data.error);
  if (data?.message) return String(data.message);

  // Validation errors arrive as { errors: { field: ['msg'] } }
  if (data?.errors && typeof data.errors === 'object') {
    const first = Object.values(data.errors).flat().find(Boolean);
    if (first) return String(first);
  }

  if (error?.message) return String(error.message);

  return fallback;
};

/** True when the request never reached the server. */
export const isNetworkError = (error) => Boolean(error?.request) && !error?.response;
